import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { useAtom } from 'jotai';
import { chartAtom } from "../../atoms/chartAtom";
import Chart from "../tables-charts/Chart";
import ChartMenu from "../tables-charts/ChartMenu";
import {
    Card,
    CardBody,
    CardFooter
  } from 'reactstrap';

export default function ChartHandler() {
  const { uid } = useParams();
  const [chartData, setChartData] = useAtom(chartAtom);

  const defaultInterval = 'Hour';
  const selectedInterval = chartData.Interval || defaultInterval;

  const fetchData = async () => {
    try {
      const response = await axios.get(`https://windmonitoring.net/api/chartData?interval=${selectedInterval}&SiteUID=${uid}`);
      updateChartAtom(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const { isLoading, isError, error } = useQuery({
    queryKey: ['chartData', uid, selectedInterval],
    queryFn: fetchData,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  const updateChartAtom = (fetchedData) => {
    setChartData((prevChartState) => ({
      ...prevChartState,
      chartData: fetchedData.map((item) => ({
        ...item,
        Interval: selectedInterval,
      })),
    }));
  };

  // Render loading, error, or descriptive text
  const renderLoadingOrError = () => {
    if (isLoading) {
      return <div>Loading...</div>;
    }

    if (isError) {
      // Ensure only the string version of the error is shown
      return <div className="text-danger">Error: {error.message || "An error occurred"}</div>;
    }

    if (selectedInterval === 'Year') {
      return <div>Total Monthly kWh Production Over the Last Year</div>;
    }

    return <div>Average kW Production Over the Last {selectedInterval}</div>;
  };

  return (
    <Card className="chart-card d-flex display-6 text-center justify-content-center">
      <CardBody>
        <ChartMenu defaultInterval="Hour" />
        <Chart />
      </CardBody>
      <CardFooter>{renderLoadingOrError()}</CardFooter>
    </Card>
  );
}

